import qs from 'query-string'

export function replace (node) {
  node.querySelectorAll('.glide').forEach(img => {
    const params = {}

    img.dataset.glide.split('|').forEach(glide => {
      const glideConfig = glide.split(':')

      params[glideConfig.shift()] = glideConfig.shift()
    })

    const query = qs.stringify(params)
    img.dataset.src = `/assets${img.dataset.src}?${query}`
  })
}



// WEBPACK FOOTER //
// ./themes/default/js/models/Glide.js